import appConfig from 'app-config';

const DEFAULT_LOGIN_METHODS = ['phone', 'facebook', 'google', 'apple'] as const;

export type LoginMethod = (typeof DEFAULT_LOGIN_METHODS)[number];

export const LOGIN_METHODS = DEFAULT_LOGIN_METHODS.filter(
  (method) => appConfig.availableLoginMethods?.includes(method) ?? true
);

export enum LoginBrandName {
  PHONE = 'PHONE',
  FACEBOOK = 'Facebook',
  GOOGLE = 'Google',
  APPLE = 'Apple',
}
